/**
 * Menu de telemóvel: um painel que entra da esquerda.
 *
 * O painel já vem no HTML, escondido com `hidden`. Abrir não pede nada ao
 * servidor, e quem não tiver JavaScript continua com as categorias na segunda
 * linha do cabeçalho — que é o que se vê num ecrã largo.
 */
class ClaroMenu extends HTMLElement {
  #painel = null;
  #abrir = null;
  #fechar = null;
  #antes = null;

  connectedCallback() {
    this.#painel = this.querySelector('[data-claro-painel]');
    this.#abrir = this.querySelector('[data-claro-menu]');
    this.#fechar = this.querySelector('[data-claro-fechar]');
    if (!this.#painel || !this.#abrir) return;

    this.#abrir.addEventListener('click', () => this.#mostra());
    this.#fechar?.addEventListener('click', () => this.#esconde());

    // Clicar fora do painel fecha; o painel em si não propaga o clique
    this.#painel.addEventListener('click', (e) => {
      if (e.target === this.#painel) this.#esconde();
    });

    addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.#painel.hidden) this.#esconde();
    });
  }

  #mostra() {
    this.#antes = document.activeElement;
    this.#painel.hidden = false;

    // Dois quadros: o elemento tem de estar desenhado antes de a classe animar
    requestAnimationFrame(() => this.#painel.classList.add('claro-painel--on'));

    // Sem isto, a página continuava a deslizar por trás do painel
    document.body.style.overflow = 'hidden';
    this.#abrir.setAttribute('aria-expanded', 'true');
    this.#fechar?.focus();
  }

  #esconde() {
    this.#painel.classList.remove('claro-painel--on');
    document.body.style.overflow = '';
    this.#abrir.setAttribute('aria-expanded', 'false');

    // Só se esconde depois de a saída acabar, senão desaparece de repente
    const fim = () => {
      this.#painel.hidden = true;
      this.#painel.removeEventListener('transitionend', fim);
    };
    this.#painel.addEventListener('transitionend', fim);

    this.#antes?.focus();
  }
}

if (!customElements.get('claro-menu')) customElements.define('claro-menu', ClaroMenu);
